import { render, staticRenderFns } from "./EditAppeal.vue?vue&type=template&id=9cf65014&scoped=true&"
import script from "./EditAppeal.vue?vue&type=script&lang=js&"
export * from "./EditAppeal.vue?vue&type=script&lang=js&"
import style0 from "./EditAppeal.vue?vue&type=style&index=0&id=9cf65014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf65014",
  null
  
)

export default component.exports